import React from "react";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Политика использования cookies
        </h1>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              Что такое cookies?
            </h2>
            <p className="mb-4">
              Cookies — это небольшие текстовые файлы, которые сохраняются на вашем устройстве 
              при посещении веб-сайтов. Они помогают нам улучшить работу сайта и предоставить 
              вам более персонализированный опыт.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              Какие cookies мы используем?
            </h2>
            <div className="space-y-4">
              <div className="p-4 bg-blue-50 rounded-lg">
                <h3 className="font-semibold text-blue-800 mb-2">Обязательные cookies</h3>
                <p className="text-blue-700 text-sm">
                  Необходимы для корректной работы сайта, сохранения ваших предпочтений 
                  и результатов тестирования.
                </p>
              </div>
              
              <div className="p-4 bg-green-50 rounded-lg">
                <h3 className="font-semibold text-green-800 mb-2">Аналитические cookies</h3>
                <p className="text-green-700 text-sm">
                  Помогают нам понимать, как посетители используют наш сайт, чтобы 
                  улучшить его функциональность и содержание.
                </p>
              </div>
              
              <div className="p-4 bg-purple-50 rounded-lg">
                <h3 className="font-semibold text-purple-800 mb-2">Функциональные cookies</h3>
                <p className="text-purple-700 text-sm">
                  Запоминают ваши настройки и предпочтения для более удобного 
                  использования сайта при повторных визитах.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              Управление cookies
            </h2>
            <p className="mb-4">
              Вы можете управлять настройками cookies через настройки вашего браузера. 
              Однако отключение cookies может повлиять на функциональность сайта.
            </p>
            <div className="p-4 bg-yellow-50 rounded-lg">
              <p className="text-yellow-800 text-sm">
                <strong>Обратите внимание:</strong> Отключение cookies может привести к 
                потере результатов тестов и необходимости повторного ввода данных.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              Контактная информация
            </h2>
            <p>
              Если у вас есть вопросы о нашей политике использования cookies, 
              свяжитесь с нами по адресу:{" "}
              <a href="mailto:developskillsnow@yandex.ru" className="text-blue-600 underline">
                developskillsnow@yandex.ru
              </a>
            </p>
            <p>
              Или подробнее можно почитать в{" "}
              <a
                className="js-scroll px-2"
                style={{ color: "#0a018be7" }}
                href="https://docs.google.com/document/d/1TUpDa3QHENfx4vQJ2EaEvxPZ1RJ7NQbnNY2Dx-H5HIc/edit?usp=sharing"
                role="button"
                target="_blank"
                rel="noopener noreferrer"
              >
                этом документе
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link
            to="/"
            className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            Вернуться на главную
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;